import queryString from 'query-string';
const Lang = require('lang');

/**
 * Client de consumo da api de fluxo de aprovacao
 */
const FluxosDeAprovacao = {
  /**
   * Get the url to use on the api
   * @param {Number} [id] - Id the get the model
   * @return {String} - The formed url
   */
  url(id) {
    if (!id) {
      return route('app.settings.fluxos-aprovacao.index');
    }

    return route('app.settings.fluxos-aprovacao.show', {
      fluxos_aprovacao: id
    });
  },

  /**
   * Makes the show request
   *
   * @param {Number} id - Id the get the model
   * @return {Promise}
   */
  show(id) {
    return Promise.resolve(
      $.ajax({
        method: 'GET',
        url: this.url(id)
      })
    );
  },

  /**
   * Makes the create Request (POST)
   *
   * @param {Object} data - The data to create
   * @return {Promise}
   */
  create(data) {
    if ({}.toString.call(data) === '[object Object]') {
      data = queryString.stringify(data);
    }

    return Promise.resolve(
      $.ajax({
        method: 'POST',
        url: this.url(),
        data
      })
    );
  },

  /**
   * @param {Number} id - Id of the model to update
   * @param {Object} data - Data to update the model
   * @return {Promise}
   */
  update(id, data, continueAnyway) {
    return new Promise((resolve, reject) => {
      const self = this;
      const hasDespesas = $('#despesasEmProcesso');

      if ({}.toString.call(data) === '[object Object]') {
        data._method = 'PATCH';
        data = queryString.stringify(data);
      }

      if (hasDespesas.length && !continueAnyway) {
        bootbox.confirm({
          title: Lang.get('js/src/fluxos-aprovacao/Form.watch_out'),
          message: Lang.get('js/src/fluxos-aprovacao/Form.change_flux_warning'),
          buttons: {
            confirm: {
              label: Lang.get('js/common/words.yes'),
              className: 'btn-danger'
            },
            cancel: {
              label: Lang.get('js/common/words.cancel'),
            },
          },
          callback: function (result) {
            if (result) {
              resolve(
                $.ajax({
                  method: 'POST',
                  url: self.url(id),
                  data
                })
              )
            } else {
              nifty.body.overlay('hide');
            }
          }
        });
      } else {
        resolve(
          $.ajax({
            method: 'POST',
            url: self.url(id),
            data
          })
        )
      }
    });
  }

};

export default FluxosDeAprovacao;
